import React, { memo } from 'react';
import styled from 'styled-components';

import hero_img from '../../assets/BG.webp';
import short_hero_img from '../../assets/BG_new_hero_short.webp';
import short_hero_mobile_img from '../../assets/BG_new_hero_short_mobile.webp';
import CommonHelper from '../../helpers/CommonHelper';
import UIHelper from '../../helpers/UIHelper';

const NewHeroSection = (props) => {
  const isDreamRoleOrErogination = UIHelper.isDreamRoleOrErogination();

  const {
    isChooseButtonVisible = true,
    compactMode = false,
    isShortBackground = false
  } = props;

  const handleChoosePlayClick = () => {
    const position = document.getElementById('featured-scenarios').offsetTop;
    window.scrollTo({ top: position - 100, behavior: 'smooth' });
  };


  return (
    <Wrapper
      isShortBackground={isShortBackground}
      style={{
        background: compactMode == true ? 'none' : undefined,
        height: compactMode == true ? 'auto' : undefined,
        marginBottom: compactMode == true ? '20px' : undefined,
      }}
    >
      {!compactMode && (
        <InnerPlaceholder>
          <Left>
            <h1>
              <Motto>
                {isDreamRoleOrErogination
                  ? 'AI Roleplay Experiences'
                  : 'Unleash your fantasies with AI roleplay'}
              </Motto>
            </h1>

            <SubTripletsMotto isChooseButtonVisible={isChooseButtonVisible}>
              <TripletItem className={'my-1'} style={{ fontWeight: 400 }}>
                {isDreamRoleOrErogination
                  ? '- Personalized AI Companions'
                  : '- AI Companions that play by your rules'}
              </TripletItem>
              <TripletItem className={'my-1'} style={{ fontWeight: 400 }}>
                {isDreamRoleOrErogination
                  ? '- Engaging and Adaptive Conversations'
                  : '- Adaptive adult conversations without limits'}
              </TripletItem>
              <TripletItem className={'my-1'} style={{ fontWeight: 400 }}>
                {isDreamRoleOrErogination
                  ? '- Explore Your Imagination in a Safe and Fun Space'
                  : '- Dive into your most daring desires'}
              </TripletItem>
            </SubTripletsMotto>
            {isChooseButtonVisible && (
              <ButtonPlaceholder>
                <OrangeButton onClick={handleChoosePlayClick}>
                  CHOOSE YOUR PLAY
                </OrangeButton>
              </ButtonPlaceholder>
            )}

            <HorTripletsPlaceholder>
              <HorTriplet>
                <HortTripletName>Safe & Secure</HortTripletName>
                <HorTripletDescription>we protect your privacy</HorTripletDescription>
              </HorTriplet>

              <HorTriplet>
                <HortTripletName>Free to try</HortTripletName>
                <HorTripletDescription>
                  Premium from $7<sup style={{ fontStyle: 'italic' }}>.49</sup>
                </HorTripletDescription>
              </HorTriplet>

              <HorTriplet>
                <HortTripletName>Create custom stories</HortTripletName>
                <HorTripletDescription>with photo, video and sound</HorTripletDescription>
              </HorTriplet>
            </HorTripletsPlaceholder>
          </Left>
        </InnerPlaceholder>
      )}
    </Wrapper>
  );
};

export default memo(NewHeroSection);

const HorTripletsPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  @media (max-width: 720px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const HortTripletName = styled.div`
  font-family: Raleway;
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
  padding-bottom: 8px;
  @media (max-width: 720px) {
    font-size: 20px;
  }
`;

const HorTripletDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  @media (max-width: 720px) {
    line-height: 18px;
  }
`;

const HorTriplet = styled.div`
  padding-right: 20px;
  border-right: 1px solid #ff7e55;
  margin-right: 20px;

  :last-of-type {
    border-right: none !important;
    margin-right: 0px;
  }

  @media (max-width: 720px) {
    border-right: none !important;
    display: inline-block;
    margin-bottom: 24px;
    padding-right: 0px !important;
    padding-bottom: 24px;

    :last-of-type {
      border-bottom: none !important;
    }
  }
`;

const TripletItem = styled.div`
  font-size: 24px;
  font-family: Raleway, sans-serif;
  font-weight: 400;
  @media (max-width: 720px) {
    font-size: 16px;
  }
  @media (max-width: 430px) {
    padding-bottom: 12px;
  }
`;

const InnerPlaceholder = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  height: 100%;
  color: white;

  font-family: Raleway, sans-serif;
  font-optical-sizing: auto;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 1280px) {
    width: 100%;
  }
  @media (max-width: 430px) {
    background: linear-gradient(-90deg, rgba(16, 13, 11, 0.1) 50.43%, rgb(16, 13, 11, 0.7) 100%);
  }
`;

const Left = styled.div`
  padding-left: 20px;
  @media (max-width: 720px) {
    padding-left: 24px;
  }
`;

const isDreamRoleOrErogination = UIHelper.isDreamRoleOrErogination();

const Motto = styled.div`
  font-size: ${isDreamRoleOrErogination ? '86px' : '50px'};
  line-height: ${isDreamRoleOrErogination ? '90px' : '56px'};

  font-weight: bold;

  @media (max-width: 720px) {
    font-size: 44px;
    line-height: 1.2;
    margin-top: 128px;
  }
`;

const SubTripletsMotto = styled.h2`
  font-size: 22px;
  margin-top: 32px;
  max-width: 720px;
  padding-bottom: ${props => (props.isChooseButtonVisible ? '30px' : '50px')};
  @media (max-width: 720px) {
    font-size: 16px;
    max-width: calc(100vw - 50px);
    margin-top: 32px;
  }
`;

const ButtonPlaceholder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 120px;
  @media (max-width: 720px) {
    padding-bottom: 60px;
  }
`;

const OrangeButton = styled.div`
  cursor: pointer;
  background: rgba(255, 126, 85, 1);
  color: white;
  font-size: 18px;
  line-height: 24px;
  height: 64px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 1000px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 700;

  @media (max-width: 720px) {
    height: 56px;
  }
`;

const Wrapper = styled.div`
  background: rgba(16, 13, 11, 1);
  font-family: Raleway, sans-serif;
  width: 100%;
  height: ${props => (props.isShortBackground ? 'auto' : 'calc(max(900px, 100vh - 50px))')};
  background-size: cover;
  background-position: center;
  background-image: ${props => {
    return props.isShortBackground
      ? `url(${CommonHelper.getEroplayCdnUrl(short_hero_img)})`
      : `url(${CommonHelper.getEroplayCdnUrl(hero_img)})`;
  }};
  background-repeat: no-repeat;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  padding: ${props => (props.isShortBackground ? '60px' : '0')};
  @media (max-width: 1072px) {
    background-image: ${`url(${CommonHelper.getEroplayCdnUrl(short_hero_mobile_img)})`};
  }};
  
    padding: 24px;
  }
  @media (max-width: 720px) {
    height: auto;
    margin-bottom: 0 !important;
  }
  @media (max-width: 430px) {
    background-image: linear-gradient(70deg, rgba(16, 13, 11, 1) 0 30%, rgba(16, 13, 11, 0) 80%),
      ${props => {
    return props.isShortBackground
      ? `url(${CommonHelper.getEroplayCdnUrl(short_hero_mobile_img)})`
      : `url(${CommonHelper.getEroplayCdnUrl(hero_img)})`;
  }};
    background-position:
      left 0px top 0px,
      right -200px top 0px;
  }
`;

